<template>
    <el-header class="head" @click="goMyInfo">
        <div class="name">{{ userName }}</div>
        <div class="party-age">党龄：{{ partyAge }}</div>
        <div class="note" @click.stop="goMessagePage">
            <div v-if="unreadCount > 0" class="unread-badge">{{ unreadCount > 99 ? '99+' : unreadCount }}</div>
        </div>
    </el-header>
    <div class="occlusion"></div>
</template>

<script>
import { formatPartyAge } from '@/utils/profile'

export default {
  name: 'TopNav',
  props: {
    profileData: {
      type: Object,
      default: () => ({})
    },
    unreadCount: {
      type: Number,
      default: 0
    }
  },
  computed: {
    userInfo() {
      return this.profileData?.user || this.profileData?.info || {}
    },
    userName() {
      return this.userInfo.real_name || '--'
    },
    partyAge() {
      return formatPartyAge(this.userInfo.join_at, this.profileData?.dtime)
    }
  },
  methods: {
    goMyInfo() {
      this.$router.push('/mine/info')
    },
    goMessagePage() {
      this.$router.push('/home/message')
    }
  }
}
</script>

<style lang="scss" scoped>
.head {
    position: relative;
    top: 0vw;
    height: 30.76923vw !important;
    width: 100%;
    background: linear-gradient(0deg, #92120e 0%, #ed6b66 100%);
    z-index: 1;
    cursor: pointer;

    .name {
        position: absolute;
        top: 7.69231vw;
        left: 5.12821vw;
        color: white;
        font-size: 4.35897vw;
        font-weight: 600;
    }

    .party-age {
        display: inline-block;
        position: absolute;
        top: 15.38462vw;
        left: 5.12821vw;
        width: auto;
        padding: 0 2.05128vw;
        color: #ffdeb7;
        background: #92120e;
        font-size: 3.58974vw;
        border-radius: 3.58974vw;
    }

    .note {
        position: absolute;
        top: 8.97436vw;
        right: 5.12821vw;
        width: 10.76923vw;
        height: 10.76923vw;
        background: #fcdfc3 url('@/assets/img/home/bell.png') no-repeat center;
        border-radius: 5.38462vw;
        box-shadow: 0vw 1.28205vw 2.5641vw rgba(0, 0, 0, 0.3);

        .unread-badge {
            position: absolute;
            top: -1vw;
            right: -2vw;
            background-color: #2cc739;
            color: #fff;
            font-size: 2.8vw;
            line-height: 4vw;
            min-width: 4vw;
            padding: 0 1.2vw;
            border-radius: 2.5vw;
            text-align: center;
            border: 0.3vw solid #fcdfc3;
            box-sizing: border-box;
            transform: scale(0.9);
            font-family: Arial, Helvetica, sans-serif;
        }
    }
}

.occlusion {
    height: 4.5vw;
    width: 100%;
    margin: -4vw auto 0;
    border-radius: 5.38462vw 5.12821vw 0 0;
    background-color: #f8f9fa;
    z-index: 2;
}
</style>
